export default "__VITE_ASSET__8abcaf03__"